import logo from "@/assets/ascflow.png";
import { Linkedin, Instagram } from "lucide-react";

const Footer = () => {
  // Ajuste fino: se cortar o "A" diminui (30). Se o azul invadir o texto aumenta (34).
  const SYMBOL_CUT = 37; // %

  const SYMBOL_BLUE = "#1B75D0";

  return (
    <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-4 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo e Descrição */}
          <div className="col-span-1 md:col-span-2">
            {/* LOGO ÚNICA (símbolo azul + texto branco) */}
            <div className="relative inline-block mb-4" style={{ width: "114px", height: "48px" }}>
              {/* Base invisível só pra medir tamanho */}
              <img src={logo} alt="" className="h-12 w-auto opacity-0" width="114" height="48" />

              {/* Texto branco (remove símbolo do lado esquerdo) */}
              <img
                src={logo}
                alt="AscFlow"
                className="absolute inset-0 h-12 w-auto brightness-0 invert"
                style={{
                  clipPath: `inset(0 0 0 ${SYMBOL_CUT}%)`,
                }}
                width="114"
                height="48"
              />

              {/* Símbolo azul (só a parte esquerda) */}
              <span
                aria-hidden="true"
                className="absolute inset-0 h-12 w-auto pointer-events-none"
                style={{
                  backgroundColor: SYMBOL_BLUE,
                  WebkitMaskImage: `url(${logo})`,
                  maskImage: `url(${logo})`,
                  WebkitMaskRepeat: "no-repeat",
                  maskRepeat: "no-repeat",
                  WebkitMaskSize: "contain",
                  maskSize: "contain",
                  WebkitMaskPosition: "left center",
                  maskPosition: "left center",
                  clipPath: `inset(0 ${100 - SYMBOL_CUT}% 0 0)`,
                }}
              />
            </div>

            <p className="text-muted-foreground max-w-md">
              Integre. Automatize. Escale. Sua empresa conectada, com fluxos
              inteligentes e automações sem esforço.
            </p>

            <div className="flex space-x-4 mt-6">
              <a
                href="https://www.linkedin.com/company/asc-es/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="LinkedIn da ASCFlow"
              >
                <Linkedin size={20} />
              </a>

              <a
                href="https://www.instagram.com/es.asc/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Instagram da ASCFlow"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">
              Links Rápidos
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#integracoes"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  Integrações
                </a>
              </li>
              <li>
                <a
                  href="#automacao"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  Automação
                </a>
              </li>
              <li>
                <a
                  href="#seguranca"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  Segurança
                </a>
              </li>
              <li>
                <a
                  href="/documentation"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  Documentação
                </a>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Contato</h3>
            <ul className="space-y-2 text-muted-foreground">
              <li>contato@asccflow.com.br</li>
              <li>
                <a href="https://wa.me/5527996259361" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
                  +55 (27) 99625-9361
                </a>
              </li>
              <li>Vitória, Espírito Santo</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-12 pt-8 text-center text-muted-foreground">
          <p>
            &copy; {new Date().getFullYear()} ASCFLOW. Todos os direitos
            reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
